import React, { useState } from 'react';
import { Map, Placemark, YMaps } from '@pbe/react-yandex-maps';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './PageContacts.scss';
import './PageContacts-media.scss';
import FormContactsExtended from '../../components/FormContactsExtended/FormContactsExtended';
import { MediaContent } from '../../services/GlobalFunctions';
import Button from '../../components/Button/Button';
import { ContactsMsk, ContactsSpb, SvgTg, SvgWhatsapp } from './constants';
import { LinkTg, MetaTags } from '../../services/content/Constants';
import Content from '../../components/Content/Content';
import { IContact, Props } from './interfaces';
import Tel from '../../components/Tel/Tel';
import MailTo from '../../components/MailTo/MailTo';
import ButtonStandalone from "../../components/Button/ButtonStandalone";

const PageContacts = ({ widthWindow }: Props) => {
  const [showMapMoscow, setShowMapMoscow] = useState(widthWindow > 720);
  const [showMapSPB, setShowMapSPB] = useState(widthWindow > 720);

  const Moscow = ContactInfo({
    contacts: ContactsMsk,
    show: showMapMoscow,
    openMap: () => setShowMapMoscow(true),
    city: 'msk'
  });

  const SPB = ContactInfo({
    contacts: ContactsSpb,
    show: showMapSPB,
    openMap: () => setShowMapSPB(true),
    city: 'spb'
  });

  return (
    <div className="page-contacts">

      <Content
        noLazy
        block={
          <>
            <h1 className="page-contacts__title">Контакты</h1>

            <div className="page-contacts__maps">
              <div className="page-contacts__map">
                {showMapMoscow && MapBlock({ contacts: ContactsMsk, widthWindow })}
                {Moscow}
              </div>
              <div className="page-contacts__map">
                {showMapSPB && MapBlock({ contacts: ContactsSpb, widthWindow })}
                {SPB}
              </div>
            </div>
          </>
        }
      />

      <Content
        block={
          <div className="page-contacts__socs">
            <div>
              <h3>Мы в мессенджерах</h3>
              <div>
                <a href={LinkTg} target="_blank" className="page-contacts__soc" rel="nofollow">
                  {SvgTg}
                </a>
                {/* <a href={LinkWhatsapp} target="_blank" className="page-contacts__soc" rel="nofollow">
              {SvgWhatsapp}
            </a> */}
              </div>
            </div>
            <div>
              <h3>Отдел продаж</h3>
              <Tel className={'mgo_num_msk'} phone="+7 (495) 646-86-82" tag="h4" />
              <MailTo mail="sale@dalli-service.com" tag="h4" />
            </div>
            <div>
              <h3>Поддержка клиентов</h3>
              <Tel phone="+7 (499) 302-64-61" tag="h4" />
              <MailTo mail="info@dalli-service.com" tag="h4" />
            </div>
          </div>
        }
      />

      <Content block={<FormContactsExtended eventMetrika="form_contacts" />} />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageContacts));

const ContactInfo = ({
  contacts: { city, phone, workingTime, address, icon },
  show,
  openMap,
  city: cityKey
}: {
  contacts: IContact;
  show: boolean;
  openMap: Function;
  city: 'msk' | 'spb'
}) => {
  return (
    <div className={`page-contacts__info${!show ? ' page-contacts__info_hide' : ''}`}>
      <div className="page-contacts__info-city">
        <div className={`page-contacts__info-city-icon page-contacts__info-city-icon_${icon}`}></div>
        <h3>{city}</h3>
      </div>
      <div className="page-contacts__info-phone">
        <a className={`mgo_num_${cityKey}`} href={`tel:${phone}`}>
          <h4>{phone}</h4>
        </a>
        <p>{workingTime}</p>
      </div>
      <h4>{address}</h4>

      {MediaContent(null, !show ? <Button text="Показать на карте" widthAll onClick={openMap} /> : null)}
    </div>
  );
};

export const MapBlock = ({
  contacts: { coords, linkToMap },
  widthWindow,
}: {
  contacts: IContact;
  widthWindow: number;
}) => {
  return (
    <YMaps>
      <Map state={{ center: coords, zoom: 16 }} width={`100%`} height={`560px`}>
        <Placemark geometry={coords} />
      </Map>
      <div className="page-contacts__link-to-ymaps">
        <ButtonStandalone
          text="Открыть в Яндекс.Картах"
          size="M"
          linkOut
          link={linkToMap}
          icon
          widthAll={widthWindow < 720}
        />
      </div>
    </YMaps>
  );
};
